import { I18n } from 'react-redux-i18n';
import { take, put, call, all, select } from 'redux-saga/effects';
import { notify } from '../../../../../Components/Notifier/services/saga';

import { handlePatchVariable } from '../../../../VariableServer/service/saga';

import {
	initApiData,
	preGenerateLinkPartnerToCustomer,
	setActiveAuthLink,
	setApiMask,
	setPartnerMedDefaut,
} from '../saga';
import {
	PRE_CHANGE_PARTNER_STATUS_TO_MED_DEFAULT,
	PRE_CHANGE_PARTNER_STEP,
} from '../types';

const PARTNER_PREFIX = 'odk';
const LADDITION_TICKET_PREFIX = 'ladditionTicket';

function* config() {
	while (true) {
		const { data } = yield take('PUT_CONFIG_ODK');
		let success = false;
		let errorMessage = null;
		let currentStep = data.step;

		let bodySetStep = {
			id_user: data.userId,
			partner_id: data.partnerId,
			step: data.nextStep,
			status: data.status,
		};

		const { partners } = yield select();
		let external_id =
			partners && partners[PARTNER_PREFIX]
				? partners[PARTNER_PREFIX].external_id
				: null;

		if (currentStep === 'initial') {
			yield call(setPartnerMedDefaut, {
				partnerPrefix: data.prefix,
				partnerId: data.partnerId,
			});
			currentStep = 'set_api_data';
			bodySetStep.step = 'set_api_data';
			success = true;
		}

		if (currentStep === 'set_api_data') {
			const successInitApiData = yield call(initApiData, PARTNER_PREFIX);
			if (successInitApiData) {
				success = true;
				bodySetStep.step = 'set_api_key';
			}
		}

		if (currentStep === 'set_api_key') {
			if (data.api_key) {
				yield call(handlePatchVariable, {
					key: 'odkApiKey',
					value: data.api_key,
				});

				const odkCompanyId = data.api_key.split(':')[0];
				external_id = odkCompanyId;
				yield put({
					type: 'PRE_PATCH_PARTNER_EXTERNAL_ID',
					body: { prefix: PARTNER_PREFIX, external_id },
				});
			}

			yield put({
				type: 'PRE_REQUEST_POST_PARTNER_CHECKING',
				body: {
					partnerPrefix: PARTNER_PREFIX,
					id: data.userId,
					uuid: external_id,
				},
			});
			const { result } = yield take('REQUEST_POST_PARTNER_CHECKING_FINISHED');

			if (
				result &&
				result.status === 'success' &&
				result.responseData === 'hello'
			) {
				currentStep = 'set_auth_link';
				bodySetStep.step = 'set_auth_link';
				success = true;

				yield call(notify, I18n.t('partner.api_key_verified'), 'success');
			} else {
				errorMessage = 'partner.onboarding_como_errors.' + currentStep;
			}
		}

		if (currentStep === 'set_auth_link') {
			if (external_id) {
				let res = yield call(preGenerateLinkPartnerToCustomer, {
					partnerId: data.partnerId,
					uuid: external_id,
				});

				if (res && res.success) {
					yield call(
						setActiveAuthLink,
						false,
						bodySetStep.id_user,
						data.partnerId
					);
					currentStep = 'set_laddition_ticket';
					bodySetStep.step = 'set_laddition_ticket';
					success = true;
				} else {
					errorMessage = 'partner.onboarding_common_errors.' + currentStep;
				}
			} else {
				errorMessage = 'partner.onboarding_common_errors.' + currentStep;
			}
		}

		if (currentStep === 'set_laddition_ticket') {
			const { partners, partnersConfig } = yield select();

			// l'id du partenaire se recupere via partnersConfig, pas via partners
			const ladditionTicketConfig = Object.values(partnersConfig).find(
				p => p.prefix === LADDITION_TICKET_PREFIX
			);
			const ladditionTicketId = ladditionTicketConfig
				? ladditionTicketConfig.partner_id
				: null;
			const ladditionTicket =
				partners && partners[LADDITION_TICKET_PREFIX]
					? partners[LADDITION_TICKET_PREFIX]
					: null;
			const alreadyConfigured = Boolean(
				ladditionTicket && ladditionTicket.external_id
			);

			if (!ladditionTicketId) {
				errorMessage = 'partner.onboarding_odk_errors.set_laddition_ticket';
			} else if (alreadyConfigured) {
				let activated = true;

				if (!ladditionTicket.active) {
					yield put({
						type: PRE_CHANGE_PARTNER_STATUS_TO_MED_DEFAULT,
						body: {
							id_user: data.userId,
							partner_id: ladditionTicketId,
							status: 'actif',
							prefix: LADDITION_TICKET_PREFIX,
						},
					});
					const activation = yield take(
						'CHANGE_PARTNER_STATUS_TO_MED_DEFAULT_RESULT'
					);
					activated = Boolean(activation && activation.success);
				}

				if (activated) {
					currentStep = 'set_api_mask';
					bodySetStep.step = 'set_api_mask';
					success = true;
				} else {
					errorMessage = 'partner.onboarding_odk_errors.set_laddition_ticket';
				}
			} else {
				// on reprend la config existante si il y en a une
				const dataTicket = {
					userId: data.userId,
					partnerId: ladditionTicketId,
					step: ladditionTicketConfig.state || 'initial',
					status: ladditionTicketConfig.status || 'configuration',
				};

				yield put({
					type: 'PUT_CONFIG_LADDITIONTICKET',
					data: dataTicket,
					automatic: true,
				});

				const { step: ladditionTicketStep } = yield take(
					'PUT_CONFIG_LADDITIONTICKET_FINISHED'
				);
				if (ladditionTicketStep === 'success') {
					success = true;
					currentStep = 'set_api_mask';
					bodySetStep.step = 'set_api_mask';
				} else {
					errorMessage = 'partner.onboarding_odk_errors.set_laddition_ticket';
				}
			}
		}

		if (currentStep === 'set_api_mask') {
			bodySetStep.status = 'actif';
			const setApiMaskSuccess = yield call(setApiMask, {
				...bodySetStep,
				prefix: PARTNER_PREFIX,
			});

			if (setApiMaskSuccess) {
				success = true;
				bodySetStep.status = 'actif';
				bodySetStep.step = 'success';
				currentStep = 'success';
			}
		}

		if (success) {
			yield put({
				type: PRE_CHANGE_PARTNER_STEP,
				body: bodySetStep,
			});
		}

		if (errorMessage) {
			yield call(notify, I18n.t(errorMessage), 'error', 5000);
		}

		yield put({
			type: 'PUT_CONFIG_ODK_FINISHED',
			step: bodySetStep.step,
			external_id,
		});
	}
}

export default function* indexSaga() {
	yield all([config()]);
}
